module.exports = __webpack_public_path__ + "static/img/center-banner-t1.31f5f90.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/center-banner-t1.png
// module id = Klqc
// module chunks = 1